import { useEffect, useMemo } from 'react'
import { Table, Thead, Tr, Th, Tbody, Td, Link, Text, Divider, VStack, Box, useToast } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { alertMessageAtom } from '@!/atoms/appSettingsAtom'
import { breadcrumbAtom } from '@!/atoms/breadcrumbAtom'
import { isBlank } from '@!/Util'
import { PrimaryButton } from '@!/components/Button'

const MonthlyCourseHistorie = ({ histories }) => {
  const [, setBreadcrumb] = useAtom(breadcrumbAtom)

  useEffect(() => {
    setBreadcrumb([{ name: 'マンガBANGブックス', ref: '/' }, { name: '月額コース履歴' }])
  }, [])

  const toast = useToast()
  const [alertMessage, setAlertMessage] = useAtom(alertMessageAtom)

  useEffect(() => {
    if (alertMessage) {
      toast({
        title: 'Notification',
        description: alertMessage,
        status: 'info',
        duration: 5000,
        isClosable: true,
        onCloseComplete: () => {
          setAlertMessage(null)
        },
      })
    }
  }, [alertMessage])

  const cellStyles = {
    textAlign: 'center',
    fontSize: '13px',
    lineHeight: '20px',
    w: '33.33%',
    px: 2,
  }

  const getRestoreNames = (histories) => {
    if (isBlank(histories)) return []
    return histories.filter((h) => h.restorable).map((h) => h.monthly_course_name)
  }

  const restoreNames = useMemo(() => getRestoreNames(histories), [histories])

  return (
    <VStack minHeight="50vh" justifyContent="space-between">
      <VStack spacing="0" w="full">
        <Text fontWeight="bold" py={3}>
          月額コース履歴
        </Text>
        <Divider />
        {!isBlank(restoreNames) && (
          <Box w="full" p={4}>
            <Box bg="primary.50" border="0.5px solid" borderColor="primary.400" borderRadius="base" p={2} w="full">
              <Text color="label.accent" fontSize="3xs">
                下記コースにて決済処理でエラーが発生しました。
                <br />
                {restoreNames.map((name, i) => (
                  <Text as="span" key={i} fontSize="xs" fontWeight="semibold" lineHeight="20px" fontFamily="Hiragino Sans">
                    ・{name}
                    <br />
                  </Text>
                ))}
                クレジットカードの有効期限切れ、限度額超過等の可能性があります。 大変お手数ですが、再登録ボタンより更新の手続きをお願い致します。
              </Text>
            </Box>
          </Box>
        )}
        {!isBlank(histories) ? (
          <>
            <Table w="full">
              <Thead>
                <Tr>
                  <Th {...cellStyles}>月額コース</Th>
                  <Th {...cellStyles}>登録日</Th>
                  <Th {...cellStyles}>解除日</Th>
                </Tr>
              </Thead>
              <Tbody>
                {histories.map((history, index) => (
                  <Tr key={`monthly-course-history-${index}`}>
                    <Td {...cellStyles} fontWeight="300">
                      {history.monthly_course_name}
                    </Td>
                    <Td {...cellStyles} fontWeight="300">
                      {history.created_at}
                    </Td>
                    <Td {...cellStyles} fontWeight="300">
                      {/*
                        ▼ cancelled_atがある場合の3パターン
                        1. 通常解約（cancel_typeがuser）: 再登録ボタン・エラー表示なし
                        2. 更新エラー、再登録可（cancel_typeがuser以外、restorable=true）: 再登録ボタン表示
                        3. 更新エラー、再登録不可（cancel_typeがuser以外、restorable=false）: 更新エラー表示
                      */}
                      {history.cancelled_at ? (
                        <VStack spacing={1}>
                          <Text>{history.cancelled_at}</Text>
                          {history.cancel_type === 'user' ? null : history.restorable ? (
                            <PrimaryButton
                              as="a"
                              href={`/user/payment/monthly_course/restore?order_id=${history.order_id}`}
                              size="xs"
                              fontSize="3xs"
                              width="100px"
                              height="28px"
                            >
                              再登録(更新)
                            </PrimaryButton>
                          ) : (
                            <Text color="label.accent">更新エラー</Text>
                          )}
                        </VStack>
                      ) : (
                        <Link href="/user/monthly_course_unregister">登録中</Link>
                      )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Text fontSize="3xs" p={4} w="full">
              ※ 毎月登録日と同日に自動更新(継続される限り無期限)されます。登録日が31日の場合、2月、4月、6月、9月、11月は月末最終日に更新されます。
              {!isBlank(restoreNames) && (
                <>
                  <br />※ 更新日より30日以内に再登録手続き完了で継続ボーナスを引き続き受け取ることができます。
                </>
              )}
            </Text>
          </>
        ) : (
          <Text textAlign="center" p={4}>
            月額コースに登録していません。
          </Text>
        )}
      </VStack>
      <Link href="/" py={8} fontSize="xs">
        トップに戻る
      </Link>
    </VStack>
  )
}

export default MonthlyCourseHistorie
